export const destinations: Record<string, string> = {
  'Start Growing as ONE': '/start',
  'Explore the Portal': '/product',
  'Start Free': '/signup',
  'Limited Access': '/start',
  'Book a Demo': '/demo#demo-player',
  'Experience LAMID ONE': '/start',
  'See How It Works': '/how-it-works',
  'Explore the Companion': '/product/companion',
  'Experience the Companion': '/os/companion',
  'View Plans': '/pricing',
  'Responsible AI': '/responsible-ai',
  'Create Account': '/signup',
  'Sign In': '/login',
  'Read Our Story': '/about/story',
  'Choose Your Context': '/start',
  'See the Operating Model': '/how-it-works',
  'Explore Integrations': '/integrations#integration-directory',
  'View SDKs': '/developers/sdks',
  'Read Webhook Docs': '/developers/webhooks',
  'Search Help': '/help',
  // Both uses of this label live on /help/getting-started's own content (hero + closing CTA) —
  // same self-referential no-op as 'View Pricing' above. Anchors at the guide's first real step.
  'Start the Guide': '/help/getting-started#section-832',
  'Browse Account Help': '/help/account',
  'Contact Security': '/contact',
  'Contact Accessibility': '/contact',
  'See the OS in Action': '/demo',
  'See LAMID ONE in Action': '/demo',
  'Start the Demo': '/demo#demo-player',
  'See Workflow Capability': '/product/workflows',
  'Explore LAMID ONE for Organizations': '/product/organizations',
  'Start With Clarity': '/how-it-works/clarity',
  'Experience Clarity': '/os/clarity',
  'Explore Capability': '/how-it-works/capability',
  'Build Your Rhythm': '/how-it-works/rhythm',
  'Explore the Rhythm': '/os/rhythm',
  'Start With LAMID ONE': '/start?context=Individual',
  'Explore LAMID ONE for Professionals': '/start?context=Professional',
  'Explore LAMID ONE for Creators': '/start?context=Creator',
  'Explore LAMID ONE for Founders': '/start?context=Founder',
  'Explore LAMID ONE for Teams': '/start?context=Team',
  'Explore LAMID ONE for SMEs': '/start?context=SME',
  'Explore LAMID ONE for Enterprise': '/enterprise',
  'Explore LAMID ONE for Institutions': '/enterprise',
  'Request an Organizational Demo': '/demo?tour=consistency#demo-player',
  'Talk to Our Team': '/enterprise/contact',
  Security: '/security',
  'Privacy & Data': '/trust/privacy',
  Governance: '/trust/governance',
  // Both uses of this label live on /responsible-ai's own content (hero + closing CTA) — same
  // self-referential no-op as the 'View Pricing' case above. Anchors at the page's first real
  // section (DocumentSectionSlide's own id="section-<sourceParagraph>" convention).
  'Read Our AI Principles': '/responsible-ai#section-553',
  'View Data Controls': '/os/settings/privacy',
  'Explore Enterprise Platform & Deployment': '/enterprise',
  // Both uses of this label live on the pricing page's own content (hero + closing CTA), so
  // without the anchor this was a same-route Link to the page you're already on — previously a
  // silent no-op (RouteEffects only reset scroll on pathname change). Points at the live
  // billables section (`id="billables"` in PricingFlow.tsx) instead.
  'View Pricing': '/pricing#billables',
  'Request a Conversation': '/enterprise/contact',
  'Explore Resources': '/resources',
  'Browse Insights': '/insights',
  'Browse playbooks': '/insights#playbook-library',
  'Browse Guides': '/guides',
  'Browse Case Studies': '/case-studies',
  'Explore Research': '/research',
  'Browse Product Guides': '/help/product',
  'Contact Support': '/support#support-form',
  'Read the Developer Docs': '/developers',
  'View API Reference': '/developers/api',
  'View Changelog': '/developers/changelog',
  'Explore LAMID ONE': '/product',
  'Explore Careers': '/careers',
  'Contact Media': '/press',
  'Continue to Capability': '/os/capability',
  'Continue to Consistency': '/os/consistency',
  'Enter LAMID ONE': '/os',
  'Continue to LAMID ONE': '/os',
  'Send Inquiry': 'mailto:hp@lamidconsulting.com',
  'Find Expertise': '/start',
  'Become an Expert': '/start',
  'Start an Expert Match': '/start',
  'Explore Experts': '/start',
  'View Verification Principles': '/trust/governance',
  'Strengthen Capability': '/how-it-works/capability',
  'Apply to Join the Expert Network': '/start',
};
